import { hideValidationPopup, validationPopup } from "../redux/actions";
import { deleteAccount } from "../services/UserService";

export const validateAccount = (formData, lang = "en") => {
  const errors = {};
  const requiredMessage =
    lang === "en" ? "This field is required" : "この項目は必須です";

  // Validate confirmation text
  if (!formData.confirmDelete?.trim()) {
    errors.confirmDelete = requiredMessage;
  } else if (formData.confirmDelete !== "DELETE") {
    errors.confirmDelete =
      lang === "en"
        ? "Please type 'DELETE' to confirm"
        : "'DELETE'と入力して確認してください";
  }

  return errors;
};

export const submitAccountDeletion = async (
  dispatch,
  formData,
  lang = "en"
) => {
  const errors = validateAccount(formData, lang);
  if (Object.keys(errors).length > 0) {
    const errorMessage =
      Object.keys(errors).length > 1
        ? lang === "en"
          ? "Please complete all necessary fields."
          : "必須項目を入力してください。"
        : Object.values(errors)[0];

    dispatch(
      validationPopup({
        message: errorMessage,
        icon: "horror",
        type: "error",
      })
    );
    return { success: false, errors };
  }

  dispatch(
    validationPopup({
      message: "Loading...",
      icon: "loading",
      type: "info",
    })
  );

  try {
    const response = await deleteAccount(lang);

    if (response?.data?.status) {
      dispatch(hideValidationPopup());
      dispatch(
        validationPopup({
          message: response.data.message,
          icon: "ok",
          type: "success",
        })
      );
      return { success: true };
    } else {
      dispatch(
        validationPopup({
          message: response.data.message,
          icon: "horror",
          type: "error",
        })
      );
      return { success: false, errors: { submit: response.data.message } };
    }
  } catch (error) {
    let errorMessage;

    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMessage =
            error.response.data?.message ||
            (lang === "en" ? "Invalid request" : "無効なリクエストです");
          break;
        case 401:
          errorMessage =
            lang === "en"
              ? "Please log in to delete your account"
              : "アカウントを削除するにはログインしてください";
          break;
        case 404:
          errorMessage =
            lang === "en" ? "Account not found" : "アカウントが見つかりません";
          break;
        default:
          errorMessage =
            error.response.data?.message ||
            (lang === "en"
              ? "Failed to delete account"
              : "アカウントの削除に失敗しました");
      }
    } else {
      errorMessage =
        lang === "en"
          ? "Network error occurred"
          : "ネットワークエラーが発生しました";
    }

    dispatch(
      validationPopup({
        message: errorMessage,
        icon: "horror",
        type: "error",
      })
    );

    return { success: false, errors: { submit: errorMessage } };
  }
};
